export function getStringsFileLanguage(language) {
    return language.replace(/-/, '');
}
